export function IconUWI() {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="27" height="27" rx="4" fill="#5002D7" />
      <path
        d="M24 9C22.8332 8.99956 21.6664 10.6662 20.4996 14C18.1663 20.6667 15.8331 20.6667 13.4998 14C11.1665 7.33333 8.83321 7.33333 6.49992 14C5.33328 17.3333 4.16664 19 3 19"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M24 13C22.8332 12.9999 21.6664 13.3332 20.4996 14C18.1663 15.3333 15.8331 15.3333 13.4998 14C11.1665 12.6667 8.83321 12.6667 6.49992 14C5.33328 14.6667 4.16664 15 3 15"
        stroke="white"
        strokeOpacity="0.5"
        strokeWidth="2"
      />
    </svg>
  )
}
